import { render, staticRenderFns } from "./ContributeList.vue?vue&type=template&id=2fa43fd6"
import script from "./ContributeList.vue?vue&type=script&lang=js"
export * from "./ContributeList.vue?vue&type=script&lang=js"
import style0 from "./ContributeList.vue?vue&type=style&index=0&id=2fa43fd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports